import { categoryService } from '@cabukaka/services';
import { Category } from '@cabukaka/types';
import useDataById from '../core/useDataById';

export  function useCategory({ id }: { id: string }) {
    const {
        data: category,
        loading,
        error,
        deleteItem,
        updateItem
    } = useDataById<Category>({ service: {
        ...categoryService,
        ...categoryService.baseService
    }, id });

    return {
     category,
     error,
     loading,
     deleteCategory: deleteItem,
     updateCategory: updateItem,
    }

}
